/** @jsx jsx */
import { css } from "@emotion/react";
import bnccShape from '../images/LP-versar/bg-header.png'

export const ebookStyles = css`
  background-color: #2F2C4F;
  scroll-margin-top: 200px;
  overflow: clip;
  /* background-image: url(${bnccShape}); */
  /* background-position: right; */
  background-repeat: no-repeat;
  /* object-fit: contain; */
  background-size: cover;
  /* background-position-x: right; */
  padding-top: 64px;
  padding-bottom: 64px;
  position: relative;

  @media (max-width: 850px) {
    padding-bottom: 0px;
    .col-image {
      padding: 0;
      margin-bottom: 40px;
    }
    .text-container {
      margin-bottom: 93px;
    }
  }

  .row {
    align-items: center;
  }

  img {
    width: 100%;
  }

  .col-text {
    display: flex;
    justify-content: flex-start;
  }

  .text-container {
    width: 100%;
    max-width: 380px;
    h1 {
      font-family: "owners-narrow", sans-serif;
      font-weight: 700;
      /* font-family: Montserrat; */
      font-size: 64px;
      font-style: normal;
      /* font-weight: 600; */
      line-height: 110%; /* 44px */
      letter-spacing: -0.8px;
      color: #ffffff;

      span{
        color: #CFC5E5;
      }
    }
    
    p {
      font-family: Montserrat;
      color: #CFC5E5;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%;
      margin-bottom: 48px;
      @media (max-width: 768px) {
        font-size: 24px;
      }
    }

    

  .button {
    background-color: #776AAE;
    border: 1px solid #EAECED;
    border-radius: 12px;
    color: #FFF;
    text-align: center;
    font-family: "owners-narrow", sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
    letter-spacing: -0.32px;
    text-transform: uppercase;
    padding: 15px 56px;
    position: relative;
    overflow: hidden;
    display: inline-block;

    span {
      font-weight: 700;
      z-index: 2;
      position: relative;
    }

    img{
      width: 20px;
      filter: brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%) hue-rotate(23deg) brightness(100%) contrast(106%);
      position: absolute;
      top: 50%;
      right: -20px;
      transform: translateY(-50%);
      transition: .2s ease-in-out;
    }

    :before {
      aspect-ratio: 1;
      background: #fff;
      border-radius: 50%;
      content: "";
      left: 50%;
      position: absolute;
      top: 50%;
      opacity: 0;
      transform: translate(-50%, -50%);
      transition: 0.4s;
      width: 0;
    }
  }

  .button:hover {
    background-color: #776AAE;
    text-decoration: none;

    span {
      color:#776AAE;
      text-decoration: none;
    }

    img{
      right: 30px;
      filter: brightness(0) saturate(100%) invert(41%) sepia(58%) saturate(367%) hue-rotate(211deg) brightness(95%) contrast(94%);
    }

    :before {
      width: 110%;
      opacity: 1;
    }
  }

  .button:active {
    background-color: #375F92;
  }
  }

  .mobile {
    display: flex;
    @media (min-width: 850px) {
      display: none;
    }
  }
  .desktop {
    display: flex;
    @media (max-width: 850px) {
      display: none;
    }

    img{
      width: auto;
      max-height: 649px;
      z-index: 2;
    }
  }

`

export const desktop = css`
  @media (max-width: 768px) {
    display: none;
  }
`;
export const mobile = css`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;

export const pathStyles = css`
  position: absolute;
  top: 50%;
  right: 0;
  width: auto !important;
  z-index: 0;
  opacity: 0.2;
  transform: translateY(-50%);
  @media (max-width: 768px) {
    display: none;
  }
`
export const pathStylesMobile = css`
  position: absolute;
    left: 0;
    z-index: 0;
    opacity: 0.2;
    display: none;
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`


